import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import * as Section from "@repoflow/components/section";

import * as DomainKeyRoute from "./key";
import * as ListRoute from "./list";
import * as NewRoute from "./new";

const LocalProvider = ({ match: { params }, children: Children }) => {
  const parent = Section.useSectionContext();
  const { base: parentBase, basepath: parentBasepath, schema } = parent;
  const base = `${parentBase}/key`;
  const basepath = `${parentBasepath}/key`;

  return (
    <Section.Provider
      schema={schema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, parent })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:keyId`} component={DomainKeyRoute.Content} />
          {/* Last: these paths are prefix matches, there is no `exact`. */}
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>API Keys</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:keyId`} component={DomainKeyRoute.Indice} />
            <Route path={`${basepath}`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
